import { render, staticRenderFns } from "./PortfolioGridWide.vue?vue&type=template&id=22f31a23&"
import script from "./PortfolioGridWide.vue?vue&type=script&lang=js&"
export * from "./PortfolioGridWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports